document.addEventListener('DOMContentLoaded', function() {

  // ===========================================================
  // SALE PAGE H1 STYLING
  // ===========================================================
  const saleHeaders = document.querySelectorAll('.sale-page h1');
  saleHeaders.forEach(header => {
    header.style.color = 'red';
    header.style.fontWeight = 'bold';
  });

  // ===========================================================
  // CUT-TO-LENGTH FIELD LOGIC
  // ===========================================================
  const wrapper = document.querySelector('.cut-to-length-wrapper');
  if (!wrapper) return;

  const input = wrapper.querySelector('.cut-length-input');
  if (!input) return;

  // hidden input that stays in form for Shopify submission
  let hiddenInput = document.querySelector('.cut-length-hidden');
  if (!hiddenInput) {
    hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = 'properties[Cut To Length]';
    hiddenInput.classList.add('cut-length-hidden');
    const form = wrapper.closest('form');
    if (form) form.appendChild(hiddenInput);
  }

  const CUT_LENGTH_STATE = { value: '' };

  input.addEventListener('input', e => {
    CUT_LENGTH_STATE.value = e.target.value;
    hiddenInput.value = e.target.value; // sync to hidden input
  });

  // Keep wrapper inside the form at all times
  const form = wrapper.closest('form');
  if (!form) return;

  function placeWrapperAfterNoRadio() {
    const noRadio = Array.from(document.querySelectorAll('input[type="radio"]'))
      .find(r => /^Leave (Arrows|Shafts) Full Length/.test(r.name) &&
                 r.value.toLowerCase().startsWith('no'));

    if (noRadio) {
      const noLabel = document.querySelector(`label[for="${noRadio.id}"]`);
      if (noLabel && wrapper.parentNode !== noLabel.parentNode) {
        noLabel.insertAdjacentElement('afterend', wrapper);
      }
    }
  }

  function updateCutWrapper() {
    const relevantRadios = Array.from(document.querySelectorAll('input[type="radio"]'))
      .filter(r => /^Leave (Arrows|Shafts) Full Length/.test(r.name));

    if (relevantRadios.length === 0) return;

    let showWrapper = false;

    relevantRadios.forEach(radio => {
      if (radio.checked && radio.value.toLowerCase().startsWith('no')) {
        showWrapper = true;
      }
    });

    placeWrapperAfterNoRadio();

    if (showWrapper) {
      wrapper.classList.add('visible');
      input.disabled = false;
      input.required = true;
      input.value = CUT_LENGTH_STATE.value;
      hiddenInput.value = CUT_LENGTH_STATE.value; // sync on show
    } else {
      wrapper.classList.remove('visible');
      input.disabled = true;
      input.required = false;
      input.value = '';
      hiddenInput.value = '';
    }
  }

  // Listen for changes on any radio buttons
  document.body.addEventListener('change', e => {
    if (e.target.matches('input[type="radio"]')) updateCutWrapper();
  });

  // Shopify variant change (re-rendered form)
  document.addEventListener('variant:change', updateCutWrapper);

  // MutationObserver to handle dynamically injected radios
  const observer = new MutationObserver(updateCutWrapper);
  observer.observe(document.querySelector('main') || document.body, {
    childList: true,
    subtree: true
  });

  // ===========================================================
  // VALIDATE CUT-TO-LENGTH BEFORE ADD-TO-CART
  // ===========================================================
  const productFormComponent = form.closest('product-form');

  if (productFormComponent) {
    productFormComponent.addEventListener('submit', e => {
      if (wrapper.classList.contains('visible') && !input.value.trim()) {
        // stop Shopify's internal AJAX handler
        e.preventDefault();
        e.stopImmediatePropagation();
        alert('Please enter the desired arrow length.');
        input.focus();
        return false;
      } else {
        hiddenInput.value = input.value; // sync before submit
      }
    }, { capture: true });
  }

  // Run once after a slight delay to ensure Shopify finishes rendering
  setTimeout(updateCutWrapper, 200);

});